import { AppDispatch, RootState } from '../index';
import { FetchState } from '../fetchState';
import { baseSlice, BaseType, getItem } from '../baseHelper';
import { workplaceService } from '@api/services/services';
import { TrainingDto } from '@api/models/training/TrainingDto';

export type WorkplaceTrainingsState = BaseType<TrainingDto[]>;

const initialState: WorkplaceTrainingsState = {
  state: FetchState.None,
  data: [],
};

export const workplaceTrainingsSlice = baseSlice({
  name: 'workplaceTrainings',
  initialState,
});

export const selectWorkplaceTrainingsState = (state: RootState) =>
  state.workplaceTrainings.state;
export const selectWorkplaceTrainings = (state: RootState) =>
  state.workplaceTrainings.data;
export const workplaceTrainingsActions = workplaceTrainingsSlice.actions;

export const getWorkplaceTrainings =
  (workplaceId: string) => (dispatch: AppDispatch) => {
    const handleGetData = () => {
      return workplaceService.getTrainingsByWorkplace(workplaceId);
    };

    getItem({
      dispatch,
      actions: workplaceTrainingsActions,
      getData: handleGetData,
    });
  };
